module.exports = __webpack_public_path__ + "img/671.3c57a355.png";